import { AdminModalTrigger } from "@/components/modal/adminModal";
import Link from "next/link";
import React from "react";
import FooterWrapper from "./FooterWrapper";
import { socialMediaIcons } from "@/lib/utils";

const footerLinkClass =
  "font-figtree border-t border-foreground/20 pt-4 text-start text-base font-normal leading-6 text-primary hover:underline md:border-t-0 md:pt-0";

const Footer: React.FC<{ bypassHiddenCondition?: boolean }> = ({
  bypassHiddenCondition,
}) => {
  return (
    <FooterWrapper bypassHiddenCondition={bypassHiddenCondition}>
      <div className="h-[45px]">
        <AdminModalTrigger>
          <div className="cursor-pointer py-4 text-center text-sm font-light text-muted-foreground underline">
            Admin Panel
          </div>
        </AdminModalTrigger>
      </div>
      <nav
        aria-label="Footer navigation"
        className="flex w-full flex-col gap-12 px-4 md:gap-6 md:px-20 lg:px-40"
      >
        <div className="flex w-full flex-row items-start justify-between gap-10 md:flex-row md:gap-5">
          <img
            src="/assets/logos/logomark-blue.png"
            alt="Gondola logo"
            className="hidden h-16 w-auto md:block"
            width={193}
            height={192}
            loading="lazy"
          />
          <div className="grid w-full grid-cols-1 gap-4 md:w-auto md:grid-cols-3 md:gap-6">
            <div className="flex flex-col gap-4 whitespace-nowrap">
              <Link href="/mcp" className={footerLinkClass}>
                Gondola MCP
              </Link>
              <Link href="/blog" className={footerLinkClass}>
                Blog
              </Link>
              <Link href="/deals" className={footerLinkClass}>
                Deals
              </Link>
              <Link href="/all-inclusive-resorts" className={footerLinkClass}>
                All-Inclusive Resorts
              </Link>
              <Link href="/rewards" className={footerLinkClass}>
                Rewards
              </Link>
            </div>
            <div className="flex flex-col gap-4 whitespace-nowrap">
              <Link href="/about" className={footerLinkClass}>
                About
              </Link>
              <Link href="/help" className={footerLinkClass}>
                Help Center
              </Link>
              <Link href="/contact-us" className={footerLinkClass}>
                Contact Us
              </Link>
              <Link href="/affiliate-program" className={footerLinkClass}>
                Affiliates
              </Link>
              <Link href="/partner" className={footerLinkClass}>
                Partners
              </Link>
            </div>
            <div className="flex flex-col gap-4 whitespace-nowrap">
              <Link href="/privacy" className={footerLinkClass}>
                Privacy Policy
              </Link>
              <Link href="/terms-of-service" className={footerLinkClass}>
                Terms of Service
              </Link>
              <Link href="/privacy-and-security" className={footerLinkClass}>
                Security
              </Link>
              <div className="flex gap-4 border-t border-foreground/20 pt-4 md:border-t-0 md:pt-0">
                {socialMediaIcons.map((item) => (
                  <Link
                    key={item.name}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={item.imageTransparent}
                      alt={item.alt}
                      className="h-5 w-5"
                      width={16}
                      height={17}
                      loading="lazy"
                    />
                  </Link>
                ))}{" "}
              </div>
            </div>
          </div>
        </div>

        <div className="flex w-full flex-row items-end justify-between gap-4">
          <img
            src="/assets/logos/logomark-blue.png"
            alt="Gondola logo"
            className="h-16 w-auto md:hidden"
            width={193}
            height={192}
            loading="lazy"
          />
          <div className="inline-flex flex-col items-start justify-start gap-2">
            <div className="justify-start font-figtree text-base font-medium capitalize leading-4 text-muted-foreground">
              © Gondola AI {new Date().getFullYear()}
            </div>
            <div className="justify-start font-figtree text-base font-medium leading-4 text-muted-foreground">
              Made by frequent travelers{" "}
            </div>
          </div>
        </div>
      </nav>
    </FooterWrapper>
  );
};

export default Footer;
